import { Navigate, Outlet, RouteObject } from 'react-router';

import { AuthPromptContainer } from '@sternum/web/features/auth/components/AuthPromptContainer';
import { lazyImport } from '@sternum/web/utils/lazyImport';

import { AuthContainer } from '../components/AuthContainer';
import { SsoLoginCallback } from '../components/SsoLoginCallback';
import { MFA } from '../views/mfa';

import { authPaths } from './paths';

const { Login } = lazyImport(() => import('../views/login'), 'Login');
const { SsoLogin } = lazyImport(() => import('../views/ssoLogin'), 'SsoLogin');
const { ResetPasswordView } = lazyImport(() => import('../views/resetPassword'), 'ResetPasswordView');
const { ForgotPassword } = lazyImport(() => import('../views/forgotPassword'), 'ForgotPassword');
const { SetupPassword } = lazyImport(() => import('../views/setupPassword'), 'SetupPassword');
const { RegistrationDevicesView } = lazyImport(() => import('../views/registrationDevices'), 'RegistrationDevicesView');
const { RegistrationComputeView } = lazyImport(() => import('../views/registrationCompute'), 'RegistrationComputeView');
const { SandboxLoginView } = lazyImport(() => import('../views/sandboxLogin'), 'SandboxLoginView');
const { RegistrationEmailPromptView } = lazyImport(
  () => import('../views/registrationEmailPrompt'),
  'RegistrationEmailPromptView',
);

function Layout() {
  return (
    <AuthContainer>
      <Outlet />
    </AuthContainer>
  );
}

export const authRoutes: RouteObject[] = [
  {
    path: authPaths.absolute,
    element: <Layout />,
    children: [
      { path: '', element: <Navigate to={authPaths.login.relative} /> },
      { path: authPaths.login.relative, element: <Login /> },
      { path: authPaths.ssoLogin.relative, element: <SsoLogin /> },
      { path: authPaths.resetPassword.relative, element: <ResetPasswordView /> },
      { path: authPaths.mfa.relative, element: <MFA /> },
      { path: authPaths.forgotPassword.relative, element: <ForgotPassword /> },
      { path: authPaths.setupPassword.relative, element: <SetupPassword /> },
    ],
  },
  {
    path: authPaths.registrationDevices.absolute,
    element: <RegistrationDevicesView />,
  },
  {
    path: authPaths.registrationCompute.absolute,
    element: <RegistrationComputeView />,
  },
  {
    path: authPaths.registrationEmailPrompt.absolute,
    element: (
      <AuthPromptContainer>
        <RegistrationEmailPromptView />
      </AuthPromptContainer>
    ),
  },
  {
    path: authPaths.sandboxLogin.absolute,
    element: <SandboxLoginView />,
  },
  { path: authPaths.ssoLoginCallback.absolute, element: <SsoLoginCallback /> },
];
